import { render, staticRenderFns } from "./uh-oh.vue?vue&type=template&id=24adcc47&"
import script from "./uh-oh.vue?vue&type=script&lang=ts&"
export * from "./uh-oh.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports